import { IMAGES } from "@/assets";
import { Reveal } from "@/components/Reveal";

const Frame = ({ src, alt, testid, className = "", imgClassName = "" }) => (
    <div className={`relative overflow-hidden group ${className}`}>
        <img
            src={src}
            alt={alt}
            data-testid={testid}
            className={`w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${imgClassName}`}
        />
        <div className="absolute inset-0 bg-[#03070A]/0 group-hover:bg-[#03070A]/20 transition-colors duration-500" />
    </div>
);

const Gallery = () => (
    <section id="gallery" data-testid="gallery-section" className="relative py-28 md:py-40">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
            <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                <div>
                    <p className="text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-4">Recent work</p>
                    <h2 className="font-display tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-[#F4F4F0] leading-[1.05]">
                        Water, <span className="italic text-[#00E5FF]">perfected</span>
                    </h2>
                </div>
                <p className="text-sm text-[#8A949E] max-w-xs leading-relaxed">
                    Real pools across the Central Coast — cleaned, balanced and ready to swim.
                </p>
            </Reveal>

            <div className="mt-16 md:mt-24 grid grid-cols-12 gap-4 md:gap-6">
                <Reveal className="col-span-12">
                    <Frame src={IMAGES.waterfall} alt="Stone water feature flowing into turquoise pool" testid="gallery-image-waterfall" className="aspect-[21/9]" />
                </Reveal>
                <Reveal delay={0.1} className="col-span-6 md:col-span-4">
                    <Frame src={IMAGES.poolFull} alt="Kidney-shaped pool surrounded by brick paving" testid="gallery-image-pool" className="aspect-[3/4]" />
                </Reveal>
                <Reveal delay={0.2} className="col-span-6 md:col-span-4">
                    <Frame src={IMAGES.vacuum} alt="Pool vacuum cleaning crystal clear water" testid="gallery-image-vacuum" className="aspect-[3/4] md:mt-16" />
                </Reveal>
                <Reveal delay={0.3} className="col-span-12 md:col-span-4">
                    <Frame src={IMAGES.water} alt="Sunlight dancing across pool water with palm shadows" testid="gallery-image-water" className="aspect-[4/3] md:aspect-auto md:h-full" />
                </Reveal>
                <Reveal className="col-span-12">
                    <Frame src={IMAGES.deepBlue} alt="Deep blue pool with pale stone coping" testid="gallery-image-deepblue" className="aspect-[16/9] md:aspect-[21/9]" />
                </Reveal>
            </div>
        </div>
    </section>
);

export default Gallery;
